import { useMap } from '@/hooks/useMap';
import React, { useEffect, useRef } from 'react';
import AMapLoader from '@amap/amap-jsapi-loader';
import { NormalBreadcrumb } from '@/components/Breadcrumb';
import { useRequest } from 'ahooks';
import { getDeviceMaps } from '@/api/device';
import { Form, Select } from 'antd';
import { getDevice } from '@/api';

const DeviceMap = () => {
  const { data, run } = useRequest(getDeviceMaps, {});
  console.log({ data });
  const { isInitialled, mapKey } = useMap();
  const AMapRef = useRef(null);
  const mapRef = useRef(null);
  const showMass = (list: { lat: string; lon: string; name: string; status: string }[]) => {
    console.log({ list });
    const AMap = AMapRef.current;
    // @ts-ignore
    mapRef.current?.clearMap();
    const style = [
      {
        url: 'https://a.amap.com/jsapi_demos/static/images/mass0.png',
        // @ts-ignore
        anchor: new AMap.Pixel(0, 0),
        // @ts-ignore
        size: new AMap.Size(20, 20),
      },
      {
        url: 'https://a.amap.com/jsapi_demos/static/images/mass1.png',
        // @ts-ignore
        anchor: new AMap.Pixel(0, 0),
        // @ts-ignore
        size: new AMap.Size(20, 20),
      },
      {
        url: 'https://a.amap.com/jsapi_demos/static/images/mass2.png',
        // @ts-ignore
        anchor: new AMap.Pixel(3, 3),
        // @ts-ignore
        size: new AMap.Size(5, 5),
      },
    ];
    // @ts-ignore
    const mass = new AMap.MassMarks(
      list.map((item) => ({
        lnglat: [Number(item.lon), Number(item.lat)], // 经纬度
        name: item.name,
        style: item.status === '离线' ? 0 : 1,
      })),
      {
        opacity: 0.8,
        zIndex: 111,
        cursor: 'pointer',
        style,
      },
    );
    // @ts-ignore
    const marker = new AMap.Marker({ content: ' ', map: mapRef.current });

    // @ts-ignore
    mass.on('mouseover', function (e) {
      marker.setPosition(e.data.lnglat);
      marker.setLabel({ content: e.data.name });
    });

    mass.setMap(mapRef.current);
    // console.log({ style });
  };
  const initialMap = async (list?: { lat: string; lon: string; name: string; status: string }[]) => {
    try {
      if (AMapRef.current) {
        showMass(list || []);
        return;
      }
      const AMap = await AMapLoader.load({
        key: mapKey, // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.MassMarks', 'AMap.Marker'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      });
      AMapRef.current = AMap;
      mapRef.current = new AMap.Map('device-map', {
        zoom: 4,
        center: [102.342785, 35.312316],
      });

      showMass(list || []);
    } catch {}
  };
  useEffect(() => {
    if (isInitialled) {
      initialMap(data?.result);
    }
  }, [isInitialled, data?.result]);

  const { data: deviceData } = useRequest(getDevice, { defaultParams: [{ isAll: true }] });
  return (
    <>
      <NormalBreadcrumb></NormalBreadcrumb>
      <div className="m20" style={{ position: 'relative' }}>
        <div style={{ position: 'absolute', zIndex: 1000, right: 20, top: 20 }}>
          <Form
            onValuesChange={(...[, values]) => {
              run(values);
            }}
          >
            <Form.Item name="name">
              <Select
                options={deviceData?.result?.list || []}
                allowClear
                showSearch
                optionFilterProp="name"
                placeholder="设备名称"
                style={{ width: 120 }}
                fieldNames={{ label: 'name', value: 'name' }}
              ></Select>
            </Form.Item>
            <Form.Item name="status">
              <Select
                options={[
                  { label: '在线', value: '在线' },
                  { label: '离线', value: '离线' },
                ]}
                style={{ width: '120px' }}
                placeholder="设备状态"
                allowClear
              ></Select>
            </Form.Item>
          </Form>
        </div>
        <div style={{ width: '100%', height: 'calc(100vh - 140px)' }} id="device-map"></div>
      </div>
    </>
  );
};

export default DeviceMap;
